import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const DBA = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`institutionActivitiesInfo.${index as 0}.dba`}
      control={control}
      render={({ field }) => (
        <FF2
          label="58. Alternate Name"
          field={field}
          input={(props) => <TextInput {...props} data-qa="58. Alternate Name" />}
        />
      )}
    />
  )
}
